// import { api } from "@/axios";
import router from "@/router";
import { api, setLogoutCallback } from "@/axios";
import store from "@/store";
// Set the logout callback when this module loads
setLogoutCallback(() => {
  store.dispatch("logout");
});

const state = {
  user: null,
};

const getters = {
  getUser: () => localStorage.getItem("user"), // state.user,
  isLogged: () => (localStorage.getItem("user") !== null ? true : false),
};

const actions = {
  async login({ commit }, credentials) {
    try {
      //console.log("credentials", credentials);
      const resp = await api.post("/login", credentials);
      //console.log("resp", resp);
      if (resp.status == 200) {
        let user = resp.data.user;
        user.token = resp.data.access_token;
        localStorage.setItem("user", JSON.stringify(user));
        // localStorage.setItem("token", JSON.stringify(resp.data.access_token));
        //console.log("uuu", localStorage.getItem("user"));
        commit("setUser", user);
        setLogoutCallback(() => {
          store.dispatch("logout");
        });
      }

      // if (credentials.email == "user@gmail.com") {
      //   const user = {
      //     email: "user@gmail.com",
      //     token: "token123",
      //     roles: ["admin", "user"],
      //   };
      //   localStorage.setItem("user", JSON.stringify(user));
      //   console.log("uuu", localStorage.getItem("user"));
      //   commit("setUser", user);
      // }
    } catch (error) {
      console.log("error", error);
      return false;
    }
  },
  async logout({ commit }) {
    try {
      await api.post("/logout");
    } catch (error) {
      //ignore error
    } finally {
      localStorage.removeItem("user");
      commit("setUser", null);
      setLogoutCallback(null);
      router.push("/login");
    }
    return true;
  },
};

const mutations = {
  setUser(state, user) {
    state.user = user;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
